import { useState, useEffect } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [sn, setSn] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const phone = params.get('phone');
    const snParam = params.get('sn');
    if (phone) {
      setPhoneNumber(phone);
    }
    if (snParam) {
      setSn(snParam);
    }
  }, []);

  const faqs = [
    {
      question: "Como vou receber o acesso ao curso Online?",
      answer: "Após a compra o acesso será enviado em seu email com o login para você acessar a área de membros."
    },
    {
      question: "Tenho alguma Garantia do produto?",
      answer: "Sim! Após a compra você terá uma garantia de satisfação de 7 dias, caso não seja aquilo prometido ou você não goste receberá o reembolso."
    },
    {
      question: "Como vou receber meu Certificado?",
      answer: "Após concluir o curso será enviado automaticamente em seu email."
    },
    {
      question: "Posso assistir as aulas quando quiser? E o suporte do curso como é?",
      answer: "Sim! Todas as aulas são gravadas, você poderá assistir e rever quando quiser. E sempre que precisar poderá entrar em contato com o Profissional Elétrico para dúvidas."
    },
    {
      question: "Meus dados estão protegidos neste site?",
      answer: "Totalmente seguro e protegido! O site que gerencia nossos pagamentos é 100% confiável contra golpes."
    },
    {
      question: "Quais são as formas de pagamento?",
      answer: "Pagamentos no Pix, Cartão Débito ou Crédito você recebe na hora em seu email o acesso, Pagamentos no boleto você irá receber em até 1 dia útil."
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Título */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              Principais Dúvidas
            </h2>
            <p className="text-gray-600 text-lg">
              Encontre respostas para as perguntas mais frequentes
            </p>
          </div>

          {/* Accordion */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-200"
              >
                {/* Pergunta - Botão do Accordion */}
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none hover:bg-gray-50 transition-colors"
                >
                  <span className="text-lg font-semibold text-gray-800 pr-4">
                    {faq.question}
                  </span>
                  <svg
                    className={`w-6 h-6 text-[#E18E37] flex-shrink-0 transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''
                      }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {/* Resposta - Conteúdo do Accordion */}
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                >
                  <div className="px-6 pb-5 pt-2">
                    <p className="text-gray-700 leading-relaxed border-l-4 border-[#E18E37] pl-4 bg-orange-50 py-3 rounded">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Mensagem adicional */}
          <div className="mt-12 text-center bg-gradient-to-r from-[#E18E37] to-[#E18E37] rounded-lg p-6 shadow-lg">
            <p className="text-gray-900 font-semibold text-lg mb-2">
              Ainda tem dúvidas?
            </p>
            <p className="text-gray-800 mb-4">
              Entre em contato conosco e teremos prazer em ajudá-lo!
            </p>

            {!sn &&
              < button
                onClick={() => window.open(`https://wa.me/${phoneNumber ?? "553791236238"}?text=Ol%C3%A1%2C%20gost%C3%A1ria%20de%20saber%20mais%20sobre%20o%20curso%20Aprenda%20El%C3%A9trica%20Residencial%20!`, '_blank')}
                className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors shadow-lg"
                aria-label="Fale conosco no WhatsApp"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                Falar no WhatsApp
              </button>

            }

          </div>
        </div>
      </div>
    </section >
  );
};

export default FAQ;
